import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const portfolioItems = [
  // Exterior Signage (filter-app)
  { id: 1, category: 'exterior', classFilter: 'filter-app', title: 'Exterior Storefront Sign', image: '/assets/img/portfolio/2.jpg' },
  { id: 2, category: 'exterior', classFilter: 'filter-app', title: 'Roadway Portable Board', image: '/assets/img/portfolio/1.jpg' },
  { id: 3, category: 'exterior', classFilter: 'filter-app', title: 'Illuminated Channel Sign', image: '/assets/img/portfolio/3.jpg' },
  { id: 4, category: 'exterior', classFilter: 'filter-app', title: 'Pylon Sign Board', image: '/assets/img/portfolio/4.jpg' },
  { id: 5, category: 'exterior', classFilter: 'filter-app', title: 'Illuminated Storefront Sign', image: '/assets/img/portfolio/5.jpg' },
  { id: 6, category: 'exterior', classFilter: 'filter-app', title: 'Storefront Entrance Signage', image: '/assets/img/portfolio/6.jpg' },
  { id: 7, category: 'exterior', classFilter: 'filter-app', title: 'Fascia Signage Board', image: '/assets/img/portfolio/7.jpg' },
  { id: 8, category: 'exterior', classFilter: 'filter-app', title: 'High Contrast Storefront Sign', image: '/assets/img/portfolio/8.jpg' },
  { id: 9, category: 'exterior', classFilter: 'filter-app', title: 'Roadside Portable Sign', image: '/assets/img/portfolio/9.jpg' },
  { id: 10, category: 'exterior', classFilter: 'filter-app', title: 'Pylon Brand Signage', image: '/assets/img/portfolio/10.jpg' },
  { id: 11, category: 'exterior', classFilter: 'filter-app', title: 'Outdoor Custom Banner', image: '/assets/img/portfolio/11.jpg' },
  { id: 12, category: 'exterior', classFilter: 'filter-app', title: 'Commercial Plaza Signage', image: '/assets/img/portfolio/12.jpg' },

  // Interior Displays (filter-product)
  { id: 13, category: 'interior', classFilter: 'filter-product', title: 'Internal Reception Display', image: '/assets/img/portfolio/13.jpg' },
  { id: 14, category: 'interior', classFilter: 'filter-product', title: 'Office Acrylic Board', image: '/assets/img/portfolio/14.jpg' },
  { id: 15, category: 'interior', classFilter: 'filter-product', title: 'Indoor Retail Brand Display', image: '/assets/img/portfolio/15.jpg' },
  { id: 16, category: 'interior', classFilter: 'filter-product', title: 'Wayfinding Room Indicator', image: '/assets/img/portfolio/16.jpg' },
  { id: 17, category: 'interior', classFilter: 'filter-product', title: 'Internal Corporate Lobby Sign', image: '/assets/img/portfolio/17.jpg' },
  { id: 18, category: 'interior', classFilter: 'filter-product', title: 'Custom Acrylic Menu Sign', image: '/assets/img/portfolio/18.jpg' },
  { id: 19, category: 'interior', classFilter: 'filter-product', title: 'Directional Corridor Guide', image: '/assets/img/portfolio/19.jpg' },
  { id: 20, category: 'interior', classFilter: 'filter-product', title: 'Wall-Mounted Logo Graphic', image: '/assets/img/portfolio/20.jpg' },
  { id: 21, category: 'interior', classFilter: 'filter-product', title: 'Indoor Directory Board', image: '/assets/img/portfolio/21.jpg' },
  { id: 22, category: 'interior', classFilter: 'filter-product', title: 'Frosted Glass Office Wall', image: '/assets/img/portfolio/22.jpg' },
  { id: 23, category: 'interior', classFilter: 'filter-product', title: 'Reception Backlit Logo', image: '/assets/img/portfolio/23.jpg' },

  // Vehicle Wraps & Graphics (filter-branding)
  { id: 24, category: 'wraps', classFilter: 'filter-branding', title: 'Commercial Vehicle Wrap', image: '/assets/img/portfolio/24.jpg' },
  { id: 25, category: 'wraps', classFilter: 'filter-branding', title: 'Fleet Truck Graphic Decal', image: '/assets/img/portfolio/25.jpg' },
  { id: 26, category: 'wraps', classFilter: 'filter-branding', title: 'Van Wrap Advertisements', image: '/assets/img/portfolio/26.jpg' },

  // Custom Projects (filter-books)
  { id: 27, category: 'custom', classFilter: 'filter-books', title: 'Window Decals & Graphics', image: '/assets/img/portfolio/27.jpg' },
  { id: 28, category: 'custom', classFilter: 'filter-books', title: 'Custom Sandwich Board', image: '/assets/img/portfolio/28.jpg' },
  { id: 29, category: 'custom', classFilter: 'filter-books', title: 'A-Frame Board Signage', image: '/assets/img/portfolio/29.jpg' },
];

export default function Portfolio() {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const portfolioSchema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "Custom Signage Portfolio",
    "url": "https://perfectsignscanada.com/portfolio.html",
    "description": "A portfolio of custom signage, exterior signs, interior displays, vehicle wraps, and graphics by Perfect Signs Canada.",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Perfect Signs Canada",
      "url": "https://perfectsignscanada.com/"
    },
    "provider": {
      "@type": "LocalBusiness",
      "name": "Perfect Signs Canada",
      "telephone": "+1-780-554-3949",
      "email": "info@perfectsignscanada.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "6109 176 Ave NW",
        "addressLocality": "Edmonton",
        "addressRegion": "AB",
        "postalCode": "T5Y 0K8",
        "addressCountry": "CA"
      }
    }
  };

  const filteredItems = activeFilter === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeFilter);

  const openLightbox = (index) => {
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxIndex(null);
  };

  const showNext = (e) => {
    e.stopPropagation();
    setLightboxIndex((prevIndex) => (prevIndex + 1) % filteredItems.length);
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setLightboxIndex((prevIndex) => (prevIndex - 1 + filteredItems.length) % filteredItems.length);
  };

  return (
    <>
      <SEO 
        title="Custom Signage Portfolio | Perfect Signs Canada"
        description="Explore Perfect Signs Canada's custom signage work, including exterior signs, interior displays, vehicle wraps, graphics, banners, pylon signs, and custom business signage."
        keywords="custom signage portfolio, business signs Edmonton, exterior signs, interior signs, vehicle wraps, window graphics, pylon signs, channel letters, banners, custom signs Canada"
        canonical="https://perfectsignscanada.com/portfolio.html"
        schema={portfolioSchema}
      />

      {/* ======= Breadcrumbs ======= */}
      <div className="breadcrumbs d-flex align-items-center" style={{ backgroundImage: "url('/assets/img/portfolio-header.jpg')" }}>
        <div className="container position-relative d-flex flex-column align-items-center" data-aos="fade-up">
          <p className="breadcrumbs-eyebrow">Signage Portfolio</p>
          <h2 className="text-center">Custom signs that help businesses stand out before customers walk in.</h2>
          <p className="breadcrumbs-summary">Browse exterior signage, interior displays, wraps, graphics, and custom projects designed to make brands easier to notice and remember.</p>
          <ol>
            <li><Link to="/">Home</Link></li>
            <li>Signage</li>
          </ol>
        </div>
      </div>
      {/* End Breadcrumbs */}

      {/* ======= Portfolio Section ======= */}
      <section id="portfolio" className="portfolio">
        <div className="container" data-aos="fade-up">
          
          <div className="portfolio-intro" data-aos="fade-up">
            <p className="section-kicker">Our work</p>
            <h2>Signage made for real storefronts, streets, vehicles, and customer touchpoints.</h2>
            <p>Every project has a job to do: get noticed, stay readable, match the brand, and hold up in the environment where customers actually see it. Use the filters below to explore the types of signage we create.</p>
          </div>

          <div className="signage-highlights row gy-4">
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="100">
              <div className="signage-highlight">
                <i className="bi bi-eye"></i>
                <strong>High visibility</strong>
                <span>Designed for distance, contrast, readability, and location.</span>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="200">
              <div className="signage-highlight">
                <i className="bi bi-brush"></i>
                <strong>Brand consistency</strong>
                <span>Colors, layout, materials, and finish aligned with your business.</span>
              </div>
            </div>
            <div className="col-md-4" data-aos="fade-up" data-aos-delay="300">
              <div className="signage-highlight">
                <i className="bi bi-tools"></i>
                <strong>Practical execution</strong>
                <span>Guidance from concept through production and installation.</span>
              </div>
            </div>
          </div>

          <div className="portfolio-isotope" data-aos="fade-up" data-aos-delay="100">
            {/* Filter controls styled exactly like Nova */}
            <ul className="portfolio-flters">
              <li className={activeFilter === 'all' ? 'filter-active' : ''} onClick={() => { setActiveFilter('all'); setLightboxIndex(null); }}>All Signage</li>
              <li className={activeFilter === 'exterior' ? 'filter-active' : ''} onClick={() => { setActiveFilter('exterior'); setLightboxIndex(null); }}>Exterior Signage</li>
              <li className={activeFilter === 'interior' ? 'filter-active' : ''} onClick={() => { setActiveFilter('interior'); setLightboxIndex(null); }}>Interior Displays</li>
              <li className={activeFilter === 'wraps' ? 'filter-active' : ''} onClick={() => { setActiveFilter('wraps'); setLightboxIndex(null); }}>Vehicle Wraps & Graphics</li>
              <li className={activeFilter === 'custom' ? 'filter-active' : ''} onClick={() => { setActiveFilter('custom'); setLightboxIndex(null); }}>Custom Projects</li>
            </ul>

            {/* Portfolio Grid with Staggered Animations */}
            <div className="row gy-4 portfolio-container" style={{ transition: 'all 0.4s ease' }}>
              {filteredItems.map((item, index) => (
                <div key={item.id} className="col-lg-4 col-md-6 portfolio-item" data-aos="fade-up" data-aos-delay={100 + (index % 3) * 100}>
                  <div className="portfolio-wrap-card" style={{ position: 'relative', overflow: 'hidden', borderRadius: '8px' }}>
                    <img src={item.image} className="img-fluid" alt={item.title} style={{ width: '100%', height: '280px', objectFit: 'cover' }} />
                    <div className="portfolio-info">
                      <h4>{item.title}</h4>
                      <span className="preview-link" onClick={() => openLightbox(index)} style={{ cursor: 'pointer' }}>
                        <i className="bi bi-zoom-in"></i>
                      </span>
                      <Link to="/contact" className="details-link">
                        <i className="bi bi-envelope"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>
      {/* End Portfolio Section */}

      {/* Lightbox Modal */}
      {lightboxIndex !== null && (
        <div className="lightbox-modal" onClick={closeLightbox}>
          <button className="lightbox-close" onClick={closeLightbox} aria-label="Close lightbox">
            <i className="bi bi-x"></i>
          </button>
          
          <button className="lightbox-nav prev-btn" onClick={showPrev} aria-label="Previous image">
            <i className="bi bi-chevron-left"></i>
          </button>

          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img 
              src={filteredItems[lightboxIndex].image} 
              alt={filteredItems[lightboxIndex].title} 
              className="lightbox-main-img animate-zoom" 
            />
            <div className="lightbox-caption">
              <span className="lightbox-tag">{filteredItems[lightboxIndex].category}</span>
              <h3>{filteredItems[lightboxIndex].title}</h3>
              <p className="lightbox-counter">Image {lightboxIndex + 1} of {filteredItems.length}</p>
            </div>
          </div>

          <button className="lightbox-nav next-btn" onClick={showNext} aria-label="Next image">
            <i className="bi bi-chevron-right"></i>
          </button>
        </div>
      )}

      {/* Signage CTA */}
      <section className="signage-cta">
        <div className="container" data-aos="fade-up">
          <div className="row align-items-center gy-4">
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="100">
              <p className="section-kicker">Start your signage project</p>
              <h2>Have a storefront, vehicle, wall, window, or roadside sign in mind?</h2>
              <p>Tell us what you want people to notice first. We can help with the right format, size, material, layout, and next step for your business.</p>
            </div>
            <div className="col-lg-4 text-lg-end" data-aos="fade-up" data-aos-delay="250">
              <Link to="/contact" className="signage-cta-btn">Request a Quote</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
